import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["master", "dependent"]

  toggle() {
    this.dependentTarget.disabled = this.masterTarget.value !== "on"
  }
}
